<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="工艺大类">
              <a-select show-search option-filter-prop="children" v-model="queryParams.technologyCategory" >
                <a-select-option v-for="(item) in orderTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleOnSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <!-- <a @click="toggleAdvanced" class="ml8">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpMpsDistributionRatioNewExport" ref="download" />
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:scpMpsDistributionRatio:export']">导出</a-button>
      <a-button @click="$refs.importData.show()" type="primary" v-hasPermi="['scp:scpMpsDistributionRatio:import']">导入</a-button>
      <a-button @click="handleTemplate" type="primary" v-hasPermi="['scp:scpMpsDistributionRatio:template']">下载模版</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="isLoading">
          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="id"
            :scroll="{ fixScreen: true, x: 1300 }"
            :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PRODUCT_DISTRIBUTION_RATIO_LIST, // 表格方案配置唯一值
              }"
          >
            <span slot="operation" slot-scope="{ record,index }">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record,index)" v-hasPermi="['scp:scpMpsDistributionRatio:edit']">编辑</a>
              <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDeleteAlert(typeList, record)" v-hasPermi="['scp:scpMpsDistributionRatio:remove']">删除</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
            <!-- 月份 -->
            <!-- <template slot="numberOnly" slot-scope="{ record, column }">
              <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex] }}</span>
              <a-input-number
                v-if="isEdit && currentId === record.id"
                v-model="record[column.dataIndex]"
                size="small"
              />
            </template> -->
            <template slot="number" slot-scope="{ record, column }">
              <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex]?record[column.dataIndex]+'%':'' }}</span>
              <a-input-number
                v-if="isEdit && currentId === record.id"
                v-model="record[column.dataIndex]"
                size="small"
              />
              <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
            </template>
            <!-- 平均活动价 -->
            <template slot="allocationPercent" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.id">{{ record.allocationPercent?record.allocationPercent+'%':'' }}</span>
              <a-input-number v-if="isEdit && currentId === record.id" v-model="record.allocationPercent" size="small" />
            </template>
            <template slot="isStopFlag" slot-scope="{ record }">
              <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
            </template>
            <template slot="setInterval" slot-scope="{ record }">
              <span >{{ `(${record.floor}   ,     ${record.upper}]` }}</span>
            </template>
          </ls-api-table></a-spin>
        <create-data
          ref="createData"
          :url="url"
          :sopDfcBasicDataId="queryParams.versionCode"
          @handle-success="handleOk"
        />
        <import-data
          ref="importData"
          :url="url"
          :sopDfcBasicDataId="queryParams.assignmentSetId"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

      <script>
      import { generateLsTableResData } from '@/utils/util.js';
      import CreateData from './components/CreateData'
      import ImportData from './components/ImportData'
      import { apiScpMpsDistributionRatioList, apiUpdateMdmOrgSrAssignmentSets, apiDeleteScpMpsDistributionRatio, apiUpdateScpMpsDistributionRatio, apiScpMpsDistributionRatioNewExport } from '@/api/mps/basic-data/product-distribution-ratio.js';
      import DownloadModal from '@/views/components/download-modal/download-modal.vue'
      export default {
        // eslint-disable-next-line
        name: 'Product-distribution-ratio',
        components: {
          DownloadModal,
          CreateData,
          ImportData
        },
        data () {
          return {
            apiScpMpsDistributionRatioNewExport,
            commitLoading: false,
            versionCode: '',
            monthStart: '',
            monthEnd: '',
            url: '/scp/scpMpsDistributionRatio/import',
            supplyTypeOptions: [],
            orderTypeOptions: [],
            classifyOptions: [],
            monthColumns: [],
            isSetTitle: false,
            // 表格配置
            tableProps: {
              requestApi: generateLsTableResData(apiScpMpsDistributionRatioList, true),
              pageCurrent: true
            },
            isEdit: false,
            currentId: "",
            // 控制搜索展开
            advanced: true,
            isLoading: false,
            // 查询参数
            queryParams: {
                technologyCategory: undefined
            },
            // 表格多选
            selectedRowKeys: [],
            selectedRows: [],
            // 状态快码
            statusOptions: [
              {
                dictLabel: "有效",
                dictValue: "Y"
              },
              {
                dictLabel: "无效",
                dictValue: "N"
              }
            ],
            baseUomFlagOptions: [
              {
                dictLabel: "是",
                dictValue: "Y"
              },
              {
                dictLabel: "否",
                dictValue: "N"
              }
            ],
            // 表格字段
            columnsNative: [
              {
                title: '工艺大类',
                stickyFixed: 'left',
                width: 120,
                dataIndex: 'technologyCategoryDesc',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '套数下限',
                dataIndex: 'floor',
                scopedSlots: { customRender: 'numberOnly' },
                width: 120,
                align: 'center'
              },
              {
                title: '套数上限',
                dataIndex: 'upper',
                scopedSlots: { customRender: 'numberOnly' },
                width: 120,
                align: 'center'
              },
              {
                title: '套数区间',
                dataIndex: 'setInterval',
                scopedSlots: { customRender: 'setInterval' },
                ellipsis: true,
                width: 140,
                align: 'center'
              },
              {
                title: '最后修改人',
                dataIndex: 'updateName',
                ellipsis: true,
                width: 140,
                align: 'center'
              },
              {
                title: '最后修改时间',
                dataIndex: 'updateTime',
                scopedSlots: { customRender: 'updateTime' },
                ellipsis: true,
                width: 140,
                align: 'center'
              },
                {
                title: '操作',
                width: 100,
                  stickyFixed: 'right',
                align: 'center',
                dataIndex: 'operation',
                scopedSlots: { customRender: 'operation' }
                }
            ],
            columns: [],
            unitOfMeasureList: [],
            unitOfMeasureListNew: []
          }
        },
        created () {
          this.queryParams.forecastName = this.$route.params.forecastName;
          this.queryParams.versionCode = this.$route.params.versionCode;
          this.versionCode = this.$route.params.versionCode;
          this.monthEnd = this.$route.params.description;
          this.monthStart = this.$route.params.id;

           this.columns = this.columnsNative
           const lookupQueryParams = {
                lookupType: 'SCP_PRODUCT_BROAD_CATEGORY',
                current: 1,
                pageSize: 100
            }
            this.getLookupListData(lookupQueryParams).then().then(response => {
            this.orderTypeOptions = response.rows
            })
        },
        mounted () {
          this.onSearch()
        },
        methods: {
          assignmentSetIdSCHandler (val) {
            if (val) { this.queryParams.assignmentSetId = val[0].lookUpCode }
          },
                /** 下载模板操作 */
          handleTemplate () {
          this.download('scp/scpMpsDistributionRatio/template', {
          }, `默认分配比例导入模板_${new Date().getTime()}.xlsx`)
        },
          handleOnSearch () {
            this.isSetTitle = false
            this.onSearch()
          },
          handleInputChange (record, dataIndex) {

          },
          successCallBack (records) {
              // 遍历行数据
              for (let i = 0; i < records.length; i++) {
                const record = records[i]
                const detailVoList = records[i].detailVoList
                this.monthColumns = []
                  for (let i = 0; i < detailVoList.length; i++) {
                    if (!self.isSetTitle) {
                        const title = detailVoList[i].month
                        this.monthColumns.push({
                          title: title,
                          dataIndex: `month${i}`,
                          width: 120,
                          align: 'center',
                          scopedSlots: { customRender: `month` }
                        })
                     }
                     // record[`month${i}`] = detailVoList[i].salesForecast
                     const propertyName = `month${i}`;
                      const propertyValue = detailVoList[i].salesForecast;
                      this.$set(record, propertyName, propertyValue);
                }

                  if (!this.isSetTitle) { // 把数据插入到指定位置
                    // 使用扩展运算符
                    const columnsCopy = [...this.columnsNative];
                    columnsCopy.splice(9, 0, ...this.monthColumns);
                    this.columns = columnsCopy;
                  }
                  this.isSetTitle = true
              }
          },
          handleDeleteAlert (tableList, record) {
            const self = this
            this.$confirm({
            title: '警告',
            content: `真的要删除该项的数据项吗?`,
            okText: '删除',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
              self.handleDelete(tableList, record)
            }
          })
          },
          handleDelete (tableList, record) {
            // const param = {
            //   itemId: record.itemId,
            //   versionCode: record.versionCode,
            //   lookupCode: record.lookupCode
            // }
            apiDeleteScpMpsDistributionRatio(record.id).then(response => {
            if (response.code === 200) {
              this.$message.success('删除成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
          },

          handleVersionChange (val, selectList) {
            const filteredItem = selectList.filter(item => item.selectedValue === val);
           this.queryParams.description = filteredItem[0].realValue
          },
          blur (record) {
            if (!record.conversionRate || Number(record.conversionRate) <= 0) {
              this.$message.warning('折换不能为空且需大于0')
            } else {
              record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
            }
          },
          statusOnChange (record) {
            record.status = record.status === 'Y' ? 'N' : 'Y'
          },
          // 导入导出excel
          /** 导出按钮操作 */
          handleExport () {
            const params = this.queryParams
            this.$refs.download.openModal(params)
            // this.download('scp/scpMpsDistributionRatio/export', {
            //   ...this.queryParams
            // }, `默认分配比例列表_${new Date().getTime()}.xlsx`)
          },
          // 编辑
          handleEdit (record, index) {
            if (this.currentId && record.id !== this.currentId && this.isEdit) {
              this.$message.warning('请保存上次编辑的数据')
              return;
            }
            this.isEdit = true;
            this.currentId = record.id;
          },
          // 编辑-保存
          handleSave (record) {
          // const recordCopy = JSON.parse(JSON.stringify(record));
          // const detailVoList = recordCopy.detailVoList
          // for (let i = 0; i < detailVoList.length; i++) {
          //    const detailVoItem = detailVoList[i]
          //    detailVoItem.salesForecast = recordCopy[`month${i}`]
          // }
          const charStringList = ["A", "B", "C", "D", "E", "F", "G"];
          let count = 0
          for (let i = 0; i < 7; i++) {
               count += record['factory' + charStringList[i]] ? record['factory' + charStringList[i]] : 0
          }
          if (count !== 100) {
            this.$message.error('工厂总和必须为100%')
            return
          }

          apiUpdateScpMpsDistributionRatio(record).then(response => {
            if (response.code === 200) {
              this.$message.success('更新成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
          },
          handleUpdate () {
            this.commitLoading = true
            apiUpdateMdmOrgSrAssignmentSets({ assignmentSetId: this.queryParams.assignmentSetId }).then(response => {
              this.commitLoading = false
            if (response.code === 200) {
              this.$message.success('更新成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
          },
          // 取消
          handleCancel (record) {
            this.isEdit = false
            this.onSearch()
          },
          // 新增/修改框事件
          handleOk () {
            this.$refs.assignmentSetNameGS.handleSearch()
             this.onSearch()
          },
          // 表单搜索
          onSearch () {
            this.isEdit = false
           this.$refs.dataTable.searchParams = this.queryParams;
          //  this.$refs.dataTable.getData();
           this.$refs.dataTable.myPagination.current = 1
           this.getTableInfo({ technologyCategory: this.queryParams.technologyCategory, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
          },
          /** 重置按钮操作 */
          resetQuery () {
            this.isSetTitle = false
            this.queryParams = {
                technologyCategory: undefined
            }
            this.onSearch()
          },
          // 搜索框展开、收起
          toggleAdvanced () {
            this.advanced = !this.advanced
          },
                      /**
         * 在table 某个列的字段后增加列
         * key：列的字段名称
         * columnList 列表的列
         * insertColumnList 插入的新列
         *  */
        setNewColumn (key, columnList, insertColumnList) {
          const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
          const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
          if (index !== -1) {
            newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
          }
            return newArray
          },
          getTableInfo (Params) {
        if (this.isLoading) {
          return
        }
      this.isLoading = true
      apiScpMpsDistributionRatioList(Params).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.rows
          this.$refs.dataTable.myDataSource = this.tableList
          const titles = response.title
          this.columnsServe = response.title
          // 生成新的对象数组，并为每个对象添加name属性
          const newArray = titles.map((title) => {
            return {
              title: title.indexName,
              dataIndex: title.indexKey,
              scopedSlots: { customRender: 'number' },
              width: 120,
              align: 'center'
            }
          })
          const dynamicColumn = this.setNewColumn('setInterval', this.columnsNative, newArray)
          this.columns = dynamicColumn
          this.$refs.dataTable.myPagination.total = response.total
          this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.total, this.$refs.dataTable.myPagination.pageSize)
        } else {
          this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
          this.$message.error(response.msg)
        }
      }).catch((error) => {
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    }
        }
      }
      </script>

      <style scoped lang="less">
      .ml10{
        margin-left: 10px;
      }
      </style>
